import { type FC } from 'react';

export const CopyrightSymbol: FC = () => {
  return <>&copy;</>;
};
